import { takeLatest } from 'redux-saga/effects';
import { registerRowRelationsEventBroadcastListener } from '~/_shared/utils/api/broadcast.helpers';
import { noop } from '~/_shared/utils/function.helpers';
import { appStore } from '~/store/app.store';
import { rowRelationsEventReceived } from '~/store/rowRelations/rowRelations.actionCreators';
import type { RowRelationsEvent } from '~/store/rowRelations/rowRelations.types';
import { USER_WEB_SOCKET_BROADCAST_INITIALIZED } from '~/store/userData/userData.actionTypes';

export function* rowRelationsSagas() {
  yield takeLatest(USER_WEB_SOCKET_BROADCAST_INITIALIZED, registerRowRelationSocketEventsProcessor);
}

function updateRowRelationsProgress(event: RowRelationsEvent) {
  appStore.dispatch(rowRelationsEventReceived(event));
}

function registerRowRelationSocketEventsProcessor() {
  registerRowRelationsEventBroadcastListener({
    onEvent: updateRowRelationsProgress,
    onError: noop,
  });
}
